import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Reports Service Stores
 *
 * Reports → Developer metrics (views/reports/DeveloperMetrics). Both services
 * are find-only and answer a BARE ARRAY: the latest run's weekly rows, and the
 * run list (API services/system/developer-metrics/). replaceOnFind so a newer
 * run's rows replace the older run's in the cache instead of merging with
 * them. No offline copy: these are measurements of named colleagues, read by
 * live staff only.
 */
export const reportsStores: ServiceStoreConfig[] = [
  {
    name: "developer-metrics",
    options: { idField: "id", enableStorage: false, replaceOnFind: true, throwOnError: true },
  },
  {
    name: "developer-metrics/runs",
    options: { idField: "id", enableStorage: false, replaceOnFind: true, throwOnError: true },
  },
];
